<template>
  <router-view />
</template>
<script>
// import terminalService from '../../api/terminal';

export default {
};
</script>